// tslint:disable
export var PayorType;
(function (PayorType) {
    // INS
    PayorType[PayorType["INS"] = 3] = "INS";
    // PBM
    PayorType[PayorType["PBM"] = 4] = "PBM";
    // PAYER
    PayorType[PayorType["PAYER"] = 32] = "PAYER";
})(PayorType || (PayorType = {}));
//# sourceMappingURL=PayorType.js.map